import React from 'react';

import { AttachmentBadge } from '../composer/attachments/badge';

import type { Message } from '../types';

interface Props {
  message: Message;
}

export default function UserMessage({ message }: Props) {
  return (
    <div className="d-flex flex-column align-items-end mb-3">
      {message.attachments && message.attachments.length > 0 && (
        <div className="d-flex flex-wrap justify-content-end gap-1 mb-1" style={{ maxWidth: '85%' }}>
          {message.attachments.map((attachment, index) => (
            <AttachmentBadge key={index} name={attachment.name} />
          ))}
        </div>
      )}
      <div className="bg-light rounded-3 p-2" style={{ maxWidth: '85%' }}>
        {message.content}
      </div>
    </div>
  );
}
